import { CURRENCY_TO_GEO_CONSTRAINT } from "@faire/retailer-shared/consts/CURRENCY_TO_GEO_CONSTRAINT";
var ROUTES_TO_CONVERT_CURRENCY = [
    /^\/api\/product\/p_[a-z0-9]+\/product-promo-messages$/,
    /^\/api\/product\/p_[a-z0-9]+/,
    /^\/api\/search\/makers-with-filters$/,
    /^\/api\/v2\/search\/brands$/,
    /^\/api\/search\/product-first-cat-nav$/,
    /^\/api\/search\/query-products$/,
    /^\/api\/v2\/products\/search/,
    /^\/api\/cart/,
    /^\/api\/v2\/carts/,
    /^\/api\/brand-view\/b_[a-z0-9]+/,
    /^\/api\/v2\/brand-view\/b_[a-z0-9]+/,
    /^\/api\/v2\/retailers\/r_[a-z0-9]+\/boards/
];
export var isBrandPreviewInterceptorFactory = function(getIsBrandPreview, getSelectedCurrency) {
    return function(config) {
        if (getIsBrandPreview()) {
            var _config_headers;
            config.headers = (_config_headers = config.headers) !== null && _config_headers !== void 0 ? _config_headers : {};
            config.headers["X-IF-BRAND-PREVIEW"] = true;
            var previewGeoConstraint = CURRENCY_TO_GEO_CONSTRAINT[getSelectedCurrency()];
            if (!previewGeoConstraint) {
                return config;
            }
            if (!config.subdomain || config.subdomain === "www") {
                config.headers["X-BRAND-PREVIEW-GEO-CONSTRAINT"] = JSON.stringify(previewGeoConstraint);
            }
            return config;
        }
        if (config.url && ROUTES_TO_CONVERT_CURRENCY.some(function(route) {
            return config.url.match(route);
        })) {
            var _config_headers1;
            config.headers = (_config_headers1 = config.headers) !== null && _config_headers1 !== void 0 ? _config_headers1 : {};
            config.headers["X-ACCEPT-CURRENCY"] = getSelectedCurrency();
        }
        return config;
    };
};
